import { useContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Alert } from "antd";
import dayjsTZ from "../../../utils/dayjs";
import AgGridComponent from "../../AG-grid/AgGridComponent";
import PunonjesitContext from "../../punonjesit/store/PunonjesitContext";
import SpecsPeriodFilter from "../components/SpecsPeriodFilter";
import { colDefs } from "./colDefs";

const CLOCKIN_TYPES_FIELD_ID = "e685cd30-b119-11ec-829e-112b583587c7";

function Raportet() {
  const { users } = useSelector((state) => state.usersList);
  const { programFields } = useSelector((state) => state.programFields);
  const { employee, specsData } = useContext(PunonjesitContext);

  const [gridApi, setGridApi] = useState(null);

  const dayTypes = useMemo(() => {
    if (!programFields) return {};
    const idx = programFields.findIndex(
      (el) => el?.fieldId === CLOCKIN_TYPES_FIELD_ID
    );
    if (idx === -1) return {};
    const toReturn = {};
    programFields[idx]?.fieldOptions?.forEach((el) => {
      toReturn[el?.name] = el?.description;
    });
    return toReturn;
  }, [programFields]);

  const columnDefs = useMemo(() => {
    return colDefs({ dayTypes });
  }, [dayTypes]);

  const rowData = useMemo(() => {
    const data = specsData?.leaves || [];
    return data.map((el) => {
      const username = el?.clockingLogs?.[0]?.username;
      const isId =
        !!username &&
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(
          username
        );
      let createdBy;
      if (isId) {
        const user = users?.allUsers?.Items?.find(
          (u) => u?.userSub === username
        );
        if (user) {
          createdBy = `${user?.given_name || ""} ${user?.family_name || ""}`;
        }
      }
      return {
        ...el,
        createdBy: createdBy || el?.clockingLogs?.[0]?.username || "N/A",
      };
    });
  }, [specsData?.leaves, users]);

  useEffect(() => {
    if (gridApi) {
      gridApi.setGridOption?.("loading", !!specsData?.loading);
    }
  }, [gridApi, specsData?.loading]);

  const EXPORT_COLS = [
    {
      en: "approved",
      al: "Statusi i turnit",
      replace: {
        true: "I aprovuar",
        false: "I pa aprovuar",
      },
    },
    { en: "dayType", al: "Lloji i turnit", replace: dayTypes },
    { en: "createdAt", al: "Krijuar në", format: "DD/MM/YYYY" },
    { en: "clockInDate", al: "Data e turnit", format: "DD/MM/YYYY" },
    { en: "createdBy", al: "Krijuar nga" },
  ];

  return (
    <div className="globalPageWrapper">
      <SpecsPeriodFilter variant="year" />
      {!specsData?.loading && rowData.length === 0 ? (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message={`Nuk ka të dhëna për ${specsData?.periodLabel || "këtë periudhë"}`}
        />
      ) : null}
      <AgGridComponent
        gridApi={gridApi}
        rowData={rowData}
        rowSelection={{ mode: "multiRow" }}
        onGridReady={(params) => setGridApi(params.api)}
        columnDefs={columnDefs}
        headerProps={{
          items: {
            search: {
              handleClean: () => {},
            },
            icons: {
              filter: {
                filterKeys: [
                  {
                    key: "createdAt",
                    label: "Krijuar në",
                    type: "date-range",
                  },
                  {
                    key: "createdBy",
                    label: "Krijuar nga",
                    type: "string",
                  },
                ],
              },
              excel: { tableCols: EXPORT_COLS },
              pdf: { tableCols: EXPORT_COLS },
              print: { tableCols: EXPORT_COLS },
            },
          },
          exportTitle: `Lejet - ${employee?.employeeFirstName} ${employee?.employeeLastName}`,
        }}
        counterProps={{
          className: "rowFlex",
          title: "Totali i lejeve (orë përfshirë pushimin)",
          data: (rowData || []).map((el) =>
            !!el.clockInDate && el.clockOutDate
              ? dayjsTZ(el.clockOutDate)
                  .diff(dayjsTZ(el.clockInDate), "hours", true)
                  .toFixed(2)
              : 0
          ),
        }}
        idKey={"clockingId"}
      />
    </div>
  );
}

export default Raportet;
